import styles from './ItineraryFloatingButton.module.css';
import clsx from 'clsx';
interface Props {
  selected: boolean;
  onClick: () => void;
}

export const ItineraryFloatingButton = ({ selected, onClick }: Props) => {
  return (
    <div className={styles.container}>
      <button className={clsx(styles.button, selected && styles.selected)} onClick={onClick}>
        <img src="/static/images/map/calendar_white.svg" alt="Itinerary" />
      </button>
    </div>
  );
};
